module.exports = __webpack_public_path__ + "img/Gran_Coupé_mobile.8fade295.jpg";